export default "__VITE_ASSET__BwpYuiX2__"